import { AddOn, SaveMyPurchase } from "src/app/shared/models/database-models"

export const returnFormItemWithoutSoftDeletedModels = (form: SaveMyPurchase): SaveMyPurchase => {
    let items = structuredClone(form.itemList).filter(x => !x.item.Strikethrough).map(item => ({
        ...item,
        AddOnFeature: item.AddOnFeature.filter(x => !x.Strikethrough),
        budgetAllocation: item.budgetAllocation.filter(x => !x.Strikethrough)
    }))
    let result = { ...form, itemList: items, vendorsList: form.vendorsList.filter(x => !x.Strikethrough), optionToPurchase: form.optionToPurchase?.filter(x => !x.Strikethrough) }
    return result
}